import { fetchApi } from '@/services/api-client';

export const REPORTS_PATH = '/admin/reports';

export type NationalityCount = {
  code: string;
  name: string;
  flag: string;
  students: number;
  staff: number;
  total: number;
};

export type GradeDiversity = { gradeLevel: number; distinctNationalities: number; students: number };

export type NationalityReport = {
  totalNationalities: number;
  totalPeople: number;
  byNationality: NationalityCount[];
  byGrade: GradeDiversity[];
};

export const nationalitiesApi = {
  getReport: () => fetchApi<NationalityReport>(`${REPORTS_PATH}/nationalities`),
};
